const offScreenStyle = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  width: '1px',
  position: 'absolute' as const
}

const MessageBlock = ({ message, 'aria-live': ariaLive }) => {
  return (
    <div
      aria-atomic="true"
      aria-live={ariaLive}
      aria-relevant="additions"
      role="log"
      style={offScreenStyle}
    >
      {message ? message : ''}
    </div>
  )
}

export default MessageBlock
